import UserProfileSetupPage from '@/components/profile-setup/UserProfileSetupPage';

export const Route = createFileRoute({
	component: UserProfileSetupPage,
});
